@if (httpError === '409') {
<mat-error class="top-right-absolute-error-message">{{ 'mes.administration.calendar.create-holidays.notifications.error.duplicate' | translate }}</mat-error>
}

<h1 mat-dialog-title class="notification-title">{{ 'mes.administration.calendar.dialog.import-holidays' | translate }}</h1>

<mat-dialog-content>
	<div style="margin-top: 15px" (keydown.enter)="onSave()">
		<mat-label class="mat-body-1">{{ 'mes.administration.calendar.dialog.selectyear.label' | translate }}</mat-label>
		<div class="error-label mat-subtitle-2"></div>
		<mat-form-field appearance="outline" class="dialog">
			<mat-select #yearSelect [(ngModel)]="selectedYear">
				@for (year of years; track year) {
				<mat-option [value]="year">{{year}}</mat-option>
				}
			</mat-select>
		</mat-form-field>

		<mat-label class="mat-body-1">{{ 'mes.administration.calendar.dialog.select-holiday-calendar.label' | translate }}</mat-label>
		<div class="error-label mat-subtitle-2"></div>
		<mat-form-field appearance="outline" class="dialog">
			<mat-select #holidayCalendarSelect [(ngModel)]="selectedCalendar">
				@for (calendar of calendars; track calendar) {
				<mat-option [value]="calendar.countryCode">{{calendar.name}}</mat-option>
				}
			</mat-select>
		</mat-form-field>

		<mat-label class="mat-body-1">{{ 'mes.administration.calendar.create-holidays.work-task.label' | translate }}</mat-label>
		<mat-form-field appearance="outline" class="dialog">
			<mat-select #holidayWorkTaskSelect [(ngModel)]="selectedWorkTask">
				<mat-option [value]="null">{{ 'mes.administration.calendar.create-holidays.work-task.none' | translate }}</mat-option>
				@for (workTask of workTasks; track workTask) {
				<mat-option [value]="workTask.id">({{workTask.alias}}) {{ workTask.name }}</mat-option>
				}
			</mat-select>
		</mat-form-field>
	</div>
</mat-dialog-content>
<div mat-dialog-actions align="end">
	<button appPreventDoubleClick mat-flat-button color="primary" cdkFocusInitial (throttledClick)="onSave()">{{ 'mes.administration.calendar.dialog.okbtn' | translate }}</button>
	<button mat-stroked-button (click)="onCancel()" class="button-border-color">{{ 'mes.administration.calendar.dialog.cancelbtn' | translate }}</button>
</div>
